
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  DeviceKey,
  LastMessageTransmissionResponse,
} from '../entities/last-message-transmission-v1/models';
import { axiosInstance } from "../axios-instance";

class LastMessageTransmission {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getByDeviceKey(deviceKey: DeviceKey): Promise<AxiosResponse<LastMessageTransmissionResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<LastMessageTransmissionResponse>(`${this.baseUrl}/lastMessageTransmission`, {
      params: { deviceKey },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default LastMessageTransmission;
